import MarketsContainer from './containers/MarketsContainer';
export default MarketsContainer;
